<template>
    <div class="podcast-category-selector">
        <div class="podcast-category-selector__inner">
            <button
                v-t="'podcasts.category.trigger'"
                type="button"
                class="button button--big button--outlined podcast-category-selector__action"
                @click="showModal = true"
            />
        </div>
        <portal v-if="showModal" to="modals">
            <Modal
                name="podcast-categories"
                :title="$t('podcasts.detail.category')"
                no-max-width
                class="podcast-category-selector__modal"
                @closed="showModal = false"
            >
                <template #content>
                    <div class="podcast-category-selector__wrapper">
                        <div
                            v-for="n in columns"
                            :key="`podcast-category-selector-col-${n}`"
                            class="podcast-category-selector__list"
                        >
                            <PodcastCategoryNode
                                v-for="category in categoriesChunks[n - 1]"
                                :key="`podcast-category-selector-item-${category.name}`"
                                class="podcast-category-selector__item"
                                :category="category"
                                @selected="selectCategory"
                            />
                        </div>
                    </div>
                </template>
                <template #bottom>
                    <div class="podcast-category-selector__footer">
                        <button
                            class="button button--big podcast-category-selector__button podcast-category-selector__button--cancel"
                            @click="cancel"
                            v-text="$t('misc.cancel')"
                        />
                        <button
                            :disabled="!isValid"
                            :class="[
                                'button button--big',
                                'podcast-category-selector__button podcast-category-selector__button--save',
                                { 'is-disabled': !isValid }
                            ]"
                            @click="save"
                            v-text="$t('misc.save')"
                        />
                    </div>
                </template>
            </Modal>
        </portal>
    </div>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import PodcastCategoryNode from './PodcastCategoryNode';

export default {
    name: 'PodcastCategorySelector',
    components: {
        Modal,
        PodcastCategoryNode
    },
    props: {
        modelValue: {
            type: Object,
            default: null
        },
        categories: {
            type: Array,
            required: true
        },
        columns: {
            type: Number,
            default: 4
        }
    },
    emits: ['update:modelValue'],
    data: () => ({
        lastSelected: {},
        showModal: false
    }),
    computed: {
        categoriesChunks() {
            let [...chunk] = this.categories;
            const result = [];

            while (chunk.length) {
                result.push(chunk.splice(0, this.itemsPerCol));
            }
            return result;
        },

        isValid() {
            const { name = '' } = this.modelValue;
            return name !== '';
        },

        itemsPerCol() {
            return Math.ceil(this.categories.length / this.columns);
        }
    },
    watch: {
        showModal(value) {
            if (value) {
                this.lastSelected = { ...this.modelValue };
            }
        }
    },
    methods: {
        selectCategory(category) {
            if (category.active) {
                category = { name: '' };
            }
            this.$emit('update:modelValue', category);
        },
        cancel() {
            this.$emit('update:modelValue', this.lastSelected);
            this.showModal = false;
        },
        save() {
            this.lastSelected = {};
            this.showModal = false;
        }
    }
};
</script>

<style lang="scss" src="./PodcastCategorySelector.scss"></style>
